module.exports = __webpack_public_path__ + "img/cooperate_13.38c3b38f.png";